var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-xl text-lg",staticStyle:{"line-height":"36px"},domProps:{"innerHTML":_vm._s(_vm.help)}})}
var staticRenderFns = []

export { render, staticRenderFns }